import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import SessionTimeoutModal from "./SessionTimeoutModal";
import { useSelector } from "react-redux";

const SessionTimeout = () => {
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();
  const {type}  = useSelector(state=> state.userSession)

  const SESSION_TIMEOUT = 30 * 60 * 1000; // 30 minutes in milliseconds


  // Effect for managing modal state and body class
  useEffect(() => {
    if (showModal) {
      document.body.classList.add("modal-open");
    } else {
      document.body.classList.remove("modal-open");
    }
  }, [showModal]);

  // Effect for session timeout management
  useEffect(() => {
    const setSessionTimeout = () => {
      const now = new Date().getTime();
      localStorage.setItem("sessionExpiry", now + SESSION_TIMEOUT);
    };

    const checkSessionTimeout = () => {
      const sessionExpiry = localStorage.getItem("sessionExpiry");
      const token = localStorage.getItem("token");

      // Only show timeout if there's an active session
      if (token && sessionExpiry && new Date().getTime() > sessionExpiry) {
        setShowModal(true);
      }
    };

    const activityEvents = ["mousedown", "keydown", "scroll", "touchstart"];
    activityEvents.forEach((event) => {
      document.addEventListener(event, setSessionTimeout);
    });

    const interval = setInterval(checkSessionTimeout, 1000);

    return () => {
      activityEvents.forEach((event) => {
        document.removeEventListener(event, setSessionTimeout);
      });
      clearInterval(interval);
    };
  }, [navigate, SESSION_TIMEOUT]);

  const handleCloseModal = () => {
    setShowModal(false);
    document.body.classList.remove("modal-open");
    localStorage.clear();

    // Redirect based on user type
    navigate(type === "recruiter" ? "/login/recruiter" : "/login/user");

  };

  return (
    <>
      {showModal && <SessionTimeoutModal onClose={handleCloseModal} userRole={type} />}
    </>
  );
};

export default SessionTimeout;
